import { Box, Typography, Chip, styled } from '@mui/material';
import { IContact, IBusiness } from '@trii/types/dist/Contacts';

const SectionTitle = styled(Typography)({
  fontWeight: 'bold',
  marginBottom: '8px',
  marginTop: '16px',
  borderBottom: `1px solid lightgray`,
});

const TagContainer = styled(Box)({
  marginBottom: 16,
});

const StyledChip = styled(Chip)(({ theme }) => ({
  marginRight: 8,
  marginBottom: 8,
  backgroundColor: `${theme.palette.primary.main}b3`,
}));

interface LabelsSectionProps {
  contactData?: IContact | IBusiness;
  title: string;
}

const LabelsSection = ({ contactData, title }: LabelsSectionProps) => {
  if (!contactData) return null;

  if (!contactData.tags?.length) return null;

  return (
    <>
      <SectionTitle gutterBottom mt={2} variant="subtitle1">
        {title}
      </SectionTitle>
      <TagContainer>
        {contactData?.tags
          ?.filter((tag) => tag.name?.trim())
          .map((tag) => (
            <StyledChip key={tag.id} label={tag.name} color="primary" size="small" />
          ))}
      </TagContainer>
    </>
  );
};

export default LabelsSection;
